import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { reportUnexpectedError } from '../../../lib/reportError'
import { resolveRewardItemImageUrl } from '../shared/rewardItems'
import type { RewardItem, SaveRewardItemInput } from '../shared/rewardItems'

export type { SaveRewardItemInput }

async function saveBirthdayRewardItem(input: SaveRewardItemInput): Promise<RewardItem> {
  const id = input.id ?? crypto.randomUUID()
  const imageUrl = await resolveRewardItemImageUrl(id, input.imageUri)

  const { data, error } = await supabase
    .from('reward_items')
    .upsert({ id, name: input.name, description: input.description, image_url: imageUrl, active: input.active, programme: 'birthday' })
    .select('id, name, description, image_url, active')
    .single()

  if (error) {
    reportUnexpectedError(error)
    throw error
  }

  return {
    id: data.id,
    name: data.name as RewardItem['name'],
    description: data.description as RewardItem['description'],
    imageUrl: data.image_url,
    active: data.active,
  }
}

export function useSaveBirthdayRewardItem() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: saveBirthdayRewardItem,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['birthday-reward-items'] }),
  })
}
